<template>
  <div class="user-management">
    <!-- 数据说明提示 -->
    <!-- <el-alert title="数据说明" description="当前展示的是虚拟数据内容，仅供界面展示示用，非真实业务数据。" type="info" :closable="false"
      style="margin-bottom: 20px;">
    </el-alert> -->

    <div class="content-container">
      <!-- 左侧组织结构 -->
       <template v-if="orgTreeData.length > 0">
          <div class="left-sidebar">
            <div class="org-title">组织结构</div>
            <!-- <div class="search-container">
              <el-input v-model="treeSearchValue" placeholder="请输入组织名称" clearable @clear="filterNode" @input="filterNode">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div> -->

            <el-tree ref="orgTree" :data="orgTreeData" :props="treeProps" :filter-node-method="filterNode" node-key="id"
              default-expand-all :expand-on-click-node="false" @node-click="handleNodeClick" class="org-tree">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="node-label">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
       </template>

      <!-- 右侧内容区域 -->
      <div class="right-content">
        <!-- 搜索和操作栏 -->
        <div class="search-header">
          <el-row :gutter="16">
            <el-col :span="6" :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model="searchForm.userName" placeholder="请输入用户名称" clearable>
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-col>
            <el-col :span="8" :xs="24" :sm="12" :md="8" :lg="8">
              <el-date-picker v-model="searchForm.createTime" type="datetimerange" range-separator="-"
                start-placeholder="开始时间" end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions"
                style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="10" :xs="24" :sm="24" :md="8" :lg="10">
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
              <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
              <!-- <el-button type="success" icon="el-icon-download" @click="handleExport">导出</el-button> -->
            </el-col>
          </el-row>
        </div>

        <!-- 数据表格 -->
        <div class="table-container">
          <el-table :data="tableData" border v-loading="loading" style="width: 100%">
            <el-table-column prop="userName" label="用户昵称" min-width="200" align="center"></el-table-column>
            <el-table-column prop="deptName" label="部门" min-width="160" align="center"></el-table-column>
            <el-table-column prop="points" label="收益" min-width="120" align="center">
              <template slot-scope="scope">
                <span style="color: #67C23A; font-weight: bold;">${{ scope.row.points }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="totalReceived" label="当月收益" width="130" align="center">
              <template slot-scope="scope">
                <span style="color: #409EFF; font-weight: bold;">{{ scope.row.totalReceived }}</span>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="createTime" label="创建时间" min-width="160" align="center"></el-table-column> -->
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-view" @click="handleView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-bar">
          <div class="pagination-info">
            共{{ pagination.total }}条　<span>总收益：${{ summaryData.totalPoints }}</span>
          </div>
          <el-pagination
            :current-page="pagination.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            layout="sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 用户详情抽屉 -->
    <el-drawer title="用户收益记录" :visible.sync="drawerVisible" direction="rtl" :size="drawerSize"
      :before-close="handleDrawerClose">
      <div class="user-detail-container" v-if="selectedUser">
        <!-- 查询条件 -->
        <el-card class="query-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">查询条件</span>
          </div>
          <el-row :gutter="16">
            <!-- <el-col :span="6" :xs="24" :sm="12" :md="8" :lg="6">
              <el-input v-model="detailSearchForm.userName" placeholder="请输入用户名称" clearable size="small">
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-col> -->
            <el-col :span="8" :xs="24" :sm="12" :md="8" :lg="8">
              <el-date-picker 
                v-model="detailSearchForm.createTime" 
                type="datetimerange" 
                range-separator="-"
                start-placeholder="开始时间" 
                end-placeholder="结束时间" 
                format="yyyy-MM-dd HH:mm:ss" 
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']" 
                :picker-options="pickerOptions"
                size="small"
                style="width: 100%;">
              </el-date-picker>
            </el-col>
            <el-col :span="10" :xs="24" :sm="24" :md="8" :lg="10">
              <el-button type="primary" size="small" icon="el-icon-search" @click="searchDetailData">查询</el-button>
              <el-button size="small" icon="el-icon-refresh" @click="resetDetailSearch">重置</el-button>
              <!-- <el-button size="small" icon="el-icon-download" @click="exportData">导出</el-button> -->
            </el-col>
          </el-row>
        </el-card>

        <!-- 详细收益记录表格 -->
        <el-card class="detail-data-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">详细收益记录</span>
            <span class="record-count">共 {{ detailPagination.total }} 条记录</span>
          </div>

          <div v-if="detailDataList.length > 0">
            <el-table :data="detailDataList" stripe size="small" max-height="400" class="detail-data-table" v-loading="detailLoading">
              <el-table-column prop="plateFormUserId" label="账号" min-width="180" align="left">
                <template slot-scope="scope">
                  <div class="account-cell">
                    <i class="el-icon-user" style="margin-right: 6px; color: #409EFF;"></i>
                    <span>{{ scope.row.plateFormUserId || '暂无账号' }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="points" label="金额" min-width="120" align="center">
                <template slot-scope="scope">
                  <div class="amount-cell">
                    <i :class="getAmountIcon(scope.row.points)" style="margin-right: 6px;"></i>
                    <span :class="getAmountClass(scope.row.points)">
                      ${{ scope.row.points || '0.00' }}
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="detail-pagination">
              <el-pagination 
                :current-page="detailPagination.pageNum" 
                :page-sizes="[10, 20, 50, 100]"
                :page-size="detailPagination.pageSize" 
                :total="detailPagination.total" 
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleDetailSizeChange" 
                @current-change="handleDetailCurrentChange">
              </el-pagination>
            </div>
          </div>
          <div v-else class="empty-data">
            <el-empty description="暂无详细数据" :image-size="80">
              <el-button type="primary" size="small" @click="refreshRevenueData">刷新数据</el-button>
            </el-empty>
          </div>
        </el-card>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { userTableConfig, paginationConfig } from './orgConfig.js';
import { getUserDeptTree, dtCommissionSysUser, dtCommissionSysUserMember, dtCommissionSysUserSummary } from '@/api/user';

export default {
  name: 'UserManagement',
  data() {
    // 获取当天起止时间
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
    const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999);
    return {
      loading: false,
      treeSearchValue: '',
      selectedOrgId: null,

      // 组织树配置
      treeProps: {
        children: 'children',
        label: 'label'
      },

      // 组织树数据 - 从配置文件导入，可在 orgConfig.js 中修改
      orgTreeData: [],

      // 搜索表单
      searchForm: {
        userName: '',
        phone: '',
        createTime: [
          this.formatDateTime(start),
          this.formatDateTime(end)
        ]
      },

      // 表格数据 - 从配置文件导入，可在 orgConfig.js 中修改
      tableData: [],

      // 分页配置 - 从配置文件导入
      pagination: {
        ...paginationConfig,
        total: userTableConfig.length
      },

      // 抽屉相关
      drawerVisible: false,
      selectedUser: null,
      drawerSize: '50%',

      // 详细数据列表
      detailDataList: [],

      // 日期选择器配置
      pickerOptions: null,

      // 详细数据分页配置
      detailPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        sysUserId: null
      },

      // 详细数据加载状态
      detailLoading: false,

      // 详细查询表单
      detailSearchForm: {
        userName: '',
        createTime: [
          this.formatDateTime(start),
          this.formatDateTime(end)
        ]
      },

      // 累计收益相关数据
      summaryData: {
        totalPoints: 0,
        totalUsers: 0,
        avgPoints: 0
      },
      summaryLoading: false
    }
  },
  watch: {
    treeSearchValue(val) {
      this.$refs.orgTree.filter(val);
    }
  },

  methods: {
    // 累计收益
    async getDtCommissionSysUserSummary() {
      this.summaryLoading = true;
      const params = {};
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        params.startTime = this.searchForm.createTime[0];
        params.endTime = this.searchForm.createTime[1];
      }
      if (this.searchForm.userName) {
        params.userName = this.searchForm.userName;
      }
      if (this.selectedOrgId) {
        params.deptId = this.selectedOrgId;
      }
      
      try {
        const res = await dtCommissionSysUserSummary(params);
        if (res.code === 200) {
          this.summaryData = {
            totalPoints: Number(res.data?.points) || 0
          };
          console.log('累计收益数据:', res.data);
        } else {
          this.$message.error(res.message || '获取累计收益失败');
          this.summaryData = {
            totalPoints: 0,
            totalUsers: 0,
            avgPoints: 0
          };
        }
      } catch (error) {
        console.error('获取累计收益失败:', error);
        this.$message.error('获取累计收益失败，请稍后重试');
        this.summaryData = {
          totalPoints: 0,
          totalUsers: 0,
          avgPoints: 0
        };
      } finally {
        this.summaryLoading = false;
      }
    },
    formatDateTime(date) {
      const pad = n => n < 10 ? '0' + n : n;
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    async getDtCommissionSysUser() {
      const params = {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum
      };
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        params.startTime = this.searchForm.createTime[0];
        params.endTime = this.searchForm.createTime[1];
      }
      if (this.searchForm.userName) {
        params.userName = this.searchForm.userName;
      }
      if (this.selectedOrgId) {
        params.deptId = this.selectedOrgId;
      }
      try {
        let res = await dtCommissionSysUser(params);
        if (res.code == 200) {
          this.tableData = res.rows || [];
          this.pagination.total = Number(res.total) || 0;
        } else {
          this.$message.error(res.message || '获取数据失败');
        }
        console.log('API响应:', res);
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请稍后重试');
      }
    },
    // 获取账户详情
    async getDtCommissionSysUserMember(params) {
      try {
        const res = await dtCommissionSysUserMember(params);
        return res;
      } catch (error) {
        console.error('获取账户详情失败:', error);
        throw error;
      }
    },
    // 获取用户名下的账号信息
    getUserDeptTreeFun() {
      getUserDeptTree().then(res => {
        console.log('res:::::', res)
        if(res.code == 200){
          this.orgTreeData = res.data;
        }
      })
    },
    // 树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 点击树节点
    handleNodeClick(data) {
      this.selectedOrgId = data.id;
      console.log('选中组织:', data.label, data.id);
      this.pagination.pageNum = 1;
      this.getDtCommissionSysUser();
      // 调用累计收益接口
      this.getDtCommissionSysUserSummary();
      // 新增：调用账户详情方法
      // this.getDtCommissionSysUserMember(data.id);
    },

    // 搜索
    handleSearch() {
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning('请选择日期范围');
        return;
      }
      this.loading = true;
      this.pagination.pageNum = 1;
      this.getDtCommissionSysUser().finally(() => {
        this.loading = false;
      });
      // 调用累计收益接口
      this.getDtCommissionSysUserSummary();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        userName: '',
        phone: '',
        createTime: [
          this.formatDateTime(new Date(new Date().setHours(0, 0, 0, 0))),
          this.formatDateTime(new Date(new Date().setHours(23, 59, 59, 999)))
        ]
      };
      this.selectedOrgId = null;
      this.$refs.orgTree.setCurrentKey(null);
      this.pagination.pageNum = 1;
      this.getDtCommissionSysUser();
      // 调用累计收益接口
      this.getDtCommissionSysUserSummary();
    },

    // 导出
    handleExport() {
      this.$message.success('导出功能开发中...');
    },

    // 合计行只显示当前页收益合计
    getTableSummary(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (column.property === 'points') {
          // 当前页合计
          const total = this.tableData.reduce((sum, row) => sum + Number(row.points || 0), 0);
          sums[index] = '总收益：' + total.toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // 分页事件
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.getDtCommissionSysUser();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getDtCommissionSysUser();
    },

    // 查看
    handleView(row) {
      this.selectedUser = row;
      this.drawerVisible = true;
      this.detailLoading = true;
      this.detailPagination.pageNum = 1;
      this.detailPagination.pageSize = 10;
      this.detailPagination.sysUserId = row.sysUserId;
      // 初始化详细查询表单
      this.detailSearchForm = {
        userName: row.userName,
        createTime: [...(this.searchForm.createTime || [])]
      };
      this.loadDetailData(row);
    },

    // 关闭抽屉
    handleDrawerClose() {
      this.drawerVisible = false;
      this.selectedUser = null;
      this.detailDataList = [];
      this.detailSearchForm = {
        userName: '',
        createTime: []
      };
      this.detailPagination = {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        sysUserId: null
      };
    },

    // 获取在线状态类型
    getOnlineStatusType(user) {
      // 根据用户ID判断在线状态（模拟数据）
      const onlineUsers = [1, 21, 31, 51]; // 假设这些用户在线
      return onlineUsers.includes(user.userId) ? 'success' : 'info';
    },

    // 获取在线状态文本
    getOnlineStatusText(user) {
      const onlineUsers = [1, 21, 31, 51];
      return onlineUsers.includes(user.userId) ? '在线' : '离线';
    },

    // 获取最后登录时间
    getLastLoginTime(user) {
      // 模拟最后登录时间
      const lastLoginTimes = {
        1: '2025-01-13 14:30',
        21: '2025-01-13 13:45',
        22: '2025-01-13 12:20',
        31: '2025-01-13 11:15',
        32: '2025-01-13 10:30',
        33: '2025-01-13 09:45',
        41: '2025-01-13 08:20',
        42: '2025-01-12 17:30',
        51: '2025-01-13 14:15',
        52: '2025-01-13 13:20'
      };
      return lastLoginTimes[user.userId] || '从未登录';
    },

    // 获取增长率样式类
    getGrowthClass(growthRate) {
      return growthRate.includes('+') ? 'positive-growth' : 'negative-growth';
    },

    // 获取类型标签类型
    getTypeTagType(type) {
      const typeMap = {
        '收益': 'success',
        '提成': 'primary',
        '奖励': 'warning',
        '扣款': 'danger'
      };
      return typeMap[type] || 'info';
    },

    // 获取金额样式类
    getAmountClass(amount) {
      if (!amount) return 'positive-amount';
      const numAmount = parseFloat(amount.toString().replace(/[¥,]/g, ''));
      return numAmount >= 0 ? 'positive-amount' : 'negative-amount';
    },

    // 获取金额图标
    getAmountIcon(amount) {
      if (!amount) return 'el-icon-top positive-icon';
      const numAmount = parseFloat(amount.toString().replace(/[¥,]/g, ''));
      return numAmount >= 0 ? 'el-icon-top positive-icon' : 'el-icon-bottom negative-icon';
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      const statusMap = {
        '已到账': 'success',
        '处理中': 'warning',
        '已取消': 'danger',
        '待审核': 'info'
      };
      return statusMap[status] || 'info';
    },

    // 加载详细数据
    async loadDetailData(user) {
      try {
        // 构建查询参数
        const params = {
          pageSize: this.detailPagination.pageSize,
          pageNum: this.detailPagination.pageNum,
          deptId: user.deptId || user.id,
          sysUserId: this.detailPagination.sysUserId || user.sysUserId
        };

        // 添加时间范围查询条件
        if (this.detailSearchForm.createTime && this.detailSearchForm.createTime.length === 2) {
          params.startTime = this.detailSearchForm.createTime[0];
          params.endTime = this.detailSearchForm.createTime[1];
        }

        // 添加用户名称查询条件
        if (this.detailSearchForm.userName) {
          params.userName = this.detailSearchForm.userName;
        }

        // 调试信息：打印传递的参数
        console.log('详细数据查询参数:', params);
        console.log('当前分页状态:', {
          pageNum: this.detailPagination.pageNum,
          pageSize: this.detailPagination.pageSize,
          total: this.detailPagination.total,
          sysUserId: this.detailPagination.sysUserId
        });

        // 调用API获取详细数据
        const res = await this.getDtCommissionSysUserMember(params);
        
        if (res.code === 200) {
          // 处理返回的数据
          this.detailDataList = res.rows || [];
          this.detailPagination.total = Number(res.total) || 0;
          
          // 调试信息：打印返回的数据
          console.log('API返回数据:', {
            rows: res.rows,
            total: res.total,
            currentPage: res.currentPage,
            pageSize: res.pageSize
          });
          
          // 如果数据为空，显示提示
          if (this.detailDataList.length === 0) {
            this.$message.info('暂无详细数据');
          }
        } else {
          this.$message.error(res.message || '获取详细数据失败');
          this.detailDataList = [];
          this.detailPagination.total = 0;
        }
        
        console.log('详细数据API响应:', res);
      } catch (error) {
        console.error('获取详细数据失败:', error);
        this.$message.error('获取详细数据失败，请稍后重试');
        this.detailDataList = [];
        this.detailPagination.total = 0;
      } finally {
        // 无论成功失败都要关闭加载状态
        this.detailLoading = false;
      }
    },

    // 刷新收益数据
    refreshRevenueData() {
      this.$message.success('收益数据已刷新');
      this.loadDetailData(this.selectedUser);
    },

    // 查询详细数据
    searchDetailData() {
      if (!this.detailSearchForm.createTime || this.detailSearchForm.createTime.length !== 2) {
        this.$message.warning('请选择日期范围');
        return;
      }
      this.detailLoading = true;
      this.detailPagination.pageNum = 1;
      this.loadDetailData(this.selectedUser);
    },

    // 重置详细查询
    resetDetailSearch() {
      this.detailSearchForm = {
        userName: '',
        createTime: [
          this.formatDateTime(new Date(new Date().setHours(0, 0, 0, 0))),
          this.formatDateTime(new Date(new Date().setHours(23, 59, 59, 999)))
        ]
      };
      this.detailPagination.pageNum = 1;
      // 保持sysUserId不变
      this.detailLoading = true;
      this.loadDetailData(this.selectedUser);
    },

    // 详细数据分页大小改变
    handleDetailSizeChange(val) {
      console.log('分页大小改变:', val);
      this.detailPagination.pageSize = val;
      this.detailPagination.pageNum = 1;
      this.detailLoading = true;
      console.log('更新后的分页状态:', this.detailPagination);
      this.loadDetailData(this.selectedUser);
    },

    // 详细数据页码改变
    handleDetailCurrentChange(val) {
      console.log('页码改变:', val);
      this.detailPagination.pageNum = val;
      this.detailLoading = true;
      console.log('更新后的分页状态:', this.detailPagination);
      this.loadDetailData(this.selectedUser);
    },

    // 设置抽屉大小
    setDrawerSize() {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 768) {
        this.drawerSize = '100%';
      } else if (windowWidth <= 1200) {
        this.drawerSize = '70%';
      } else {
        this.drawerSize = '50%';
      }
    },

    // 导出数据
    exportData() {
      this.$message.success('导出功能开发中...');
    },
  },

  created() {
    const that = this;
    this.pickerOptions = {
      shortcuts: [
        {
          text: '今天',
          onClick(picker) {
            const start = new Date();
            start.setHours(0, 0, 0, 0);
            const end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [
              that.formatDateTime(start),
              that.formatDateTime(end)
            ]);
          }
        },
        {
          text: '昨天',
          onClick(picker) {
            const start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            const end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [
              that.formatDateTime(start),
              that.formatDateTime(end)
            ]);
          }
        },
        {
          text: '最近7天',
          onClick(picker) {
            const start = new Date();
            start.setDate(start.getDate() - 6);
            start.setHours(0, 0, 0, 0);
            const end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [
              that.formatDateTime(start),
              that.formatDateTime(end)
            ]);
          }
        },
        {
          text: '最近30天',
          onClick(picker) {
            const start = new Date();
            start.setDate(start.getDate() - 29);
            start.setHours(0, 0, 0, 0);
            const end = new Date();
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [
              that.formatDateTime(start),
              that.formatDateTime(end)
            ]);
          }
        }
      ]
    }
  },

  mounted() {
    this.getUserDeptTreeFun();
    this.setDrawerSize();
    this.getDtCommissionSysUser();
    // 初始化时调用累计收益接口
    this.getDtCommissionSysUserSummary();
    window.addEventListener('resize', this.setDrawerSize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setDrawerSize);
  }
}
</script>

<style lang="scss" scoped>
.user-management {
  padding: 16px;
  background-color: #f0f2f5;
  height: 100vh;
  overflow: hidden;

  .content-container {
    display: flex;
    gap: 16px;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    height: calc(100vh - 120px);
  }

  .left-sidebar {
    width: 320px;
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    padding: 16px;
    display: flex;
    flex-direction: column;

    .org-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 12px;
      color: #333;
    }

    .search-container {
      margin-bottom: 12px;
      flex-shrink: 0;

      .el-input {
        border-radius: 4px;
      }
    }

    .org-tree {
      flex: 1;
      overflow-y: auto;

      .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;

        .node-label {
          color: #606266;
          font-weight: 500;
        }
      }

      ::v-deep .el-tree-node__content {
        height: 32px;

        &:hover {
          background-color: #f5f7fa;
        }
      }

      ::v-deep .el-tree-node.is-current>.el-tree-node__content {
        background-color: #e6f7ff;
        border-right: 2px solid #409eff;

        .node-label {
          color: #409eff;
          font-weight: bold;
        }
      }
    }
  }

  .right-content {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .search-header {
      margin-bottom: 16px;
      flex-shrink: 0;

      .el-button {
        margin-left: 8px;
      }

      @media (max-width: 768px) {
        .el-col {
          margin-bottom: 8px;
        }
        
        .el-button {
          margin-left: 0;
          margin-right: 8px;
          margin-bottom: 8px;
        }
      }
    }

    .table-container {
      flex: 1;
      margin-bottom: 16px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      padding: 0 0 8px 0;
      .el-table {
        border-radius: 10px;
        overflow: hidden;
        ::v-deep .el-table__body-wrapper {
          max-height: 600px;
          overflow-y: auto !important;
        }
        ::v-deep .el-table__footer-wrapper {
          background: #fafbfc;
          font-weight: bold;
          color: #333;
          td {
            background: #fafbfc !important;
            border-bottom: none !important;
          }
        }
        ::v-deep .el-table__fixed-right {
          border-radius: 0 10px 10px 0;
        }
      }
    }

    .pagination-container {
      display: none;
    }

    .pagination-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 8px;
      .pagination-info {
        font-size: 14px;
        color: #666;
        margin-right: 16px;
        white-space: nowrap;
        font-weight: 500;
        span {
          color: #ff4d4f;
          font-weight: bold;
          margin-left: 8px;
        }
      }
    }
  }
}

// 响应式布局
@media (max-width: 1200px) {
  .user-management {
    .content-container {
      flex-direction: column;
      height: auto;
      min-height: calc(100vh - 120px);
    }

    .left-sidebar {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid #e8e8e8;
      max-height: 400px;

      .org-tree {
        max-height: 300px;
      }
    }

    .right-content {
      .table-container {
        .el-table {
          ::v-deep .el-table__body-wrapper {
            max-height: 400px;
          }
        }
      }
    }
  }
}

// 用户详情抽屉样式
.user-detail-container {
  padding: 16px;
  height: 100%;
  overflow-y: auto;

  .el-card {
    margin-bottom: 16px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-title {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }
    }
  }

  // 用户基本信息卡片
  .user-info-card {
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-title {
        font-size: 18px;
        font-weight: bold;
        color: #303133;
      }

      .user-dept {
        font-size: 14px;
        color: #909399;
        background-color: #f5f7fa;
        padding: 4px 12px;
        border-radius: 12px;
      }
    }
  }

  // 查询条件卡片
  .query-card {
    .card-header {
      .card-title {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }
    }
  }

  // 详细收益记录表格
  .detail-data-card {
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-title {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }

      .record-count {
        font-size: 14px;
        color: #909399;
      }
    }

    .detail-pagination {
      display: flex;
      justify-content: center;
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
    }

    .detail-data-table {
      border-radius: 8px;
      overflow: hidden;

      ::v-deep .el-table__header-wrapper {
        .el-table__header {
          th {
            background-color: #f8f9fa;
            color: #303133;
            font-weight: 600;
            border-bottom: 2px solid #e8e8e8;
          }
        }
      }

      ::v-deep .el-table__body-wrapper {
        .el-table__row {
          transition: all 0.3s ease;

          &:hover {
            background-color: #f0f9ff;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          }

          .el-table__cell {
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;
          }
        }
      }

      .date-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #606266;
      }

      .amount-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
      }

      .account-cell {
        display: flex;
        align-items: center;
        padding: 0 12px;
        font-size: 13px;
        color: #303133;
      }
    }

    .positive-amount {
      color: #67C23A;
      font-weight: bold;
      font-size: 14px;
    }

    .negative-amount {
      color: #F56C6C;
      font-weight: bold;
      font-size: 14px;
    }

    .positive-icon {
      color: #67C23A;
    }

    .negative-icon {
      color: #F56C6C;
    }

    .empty-data {
      padding: 40px 20px;
      text-align: center;
      background-color: #fafafa;
      border-radius: 6px;
      margin: 20px 0;

      ::v-deep .el-empty__description p {
        color: #909399;
        font-size: 14px;
      }

      ::v-deep .el-empty__bottom {
        margin-top: 16px;
      }
    }
  }

  // 增长率样式
  .positive-growth {
    color: #67C23A;
  }

  .negative-growth {
    color: #F56C6C;
  }
}

// 抽屉标题样式覆盖
::v-deep .el-drawer__header {
  background-color: #f8f9fa;
  padding: 16px;
  margin-bottom: 0;
  border-bottom: 1px solid #e8e8e8;

  span {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  @media (max-width: 768px) {
    padding: 12px;
    
    span {
      font-size: 16px;
    }
  }
}

::v-deep .el-drawer__body {
  padding: 0;
}

.table-summary-row {
  width: 100%;
  background: #fff;
  border: 2px solid #ff4d4f;
  border-radius: 6px;
  margin-top: 2px;
  margin-bottom: 8px;
  padding: 8px 24px 8px 0;
  text-align: right;
  font-size: 16px;
  color: #ff4d4f;
  font-weight: bold;
  box-sizing: border-box;
  .summary-label {
    margin-right: 8px;
  }
  .summary-value {
    font-size: 18px;
  }
}

// 操作列按钮样式
::v-deep .el-table__column--right .el-button {
  margin: 0 4px;
  padding: 4px 12px;
  font-size: 13px;
  border-radius: 6px;
  background: #f5f7fa;
  color: #409EFF;
  border: 1px solid #e4e7ed;
  transition: background 0.2s;
}
::v-deep .el-table__column--right .el-button:hover {
  background: #e6f7ff;
}

// 操作列宽度适中
::v-deep .el-table__fixed-right {
  min-width: 110px !important;
  max-width: 120px !important;
}
</style>